
import Breadcrumb from '@/components/Breadcrumb'
import TitleBox from '@/components/CSS/TitleBox'
import { mapGetters } from 'vuex'

export default {
    components: {
        Breadcrumb,
        TitleBox
    },
    data() {
        return {
            customerServiceData: null
        }
    },
    computed: {
        ...mapGetters({
            payInfo: 'game/payInfo',
            userAccount: 'user/userAccount'
        })
    },
    methods: {
        // 获取客服id
		// async getOrderCustomerService() {
		// 	let data = {
		// 		orderNo: this.$route.query.orderNo
		// 	}
		// 	const res = await this.$api.getOrderCustomerService(data)
		// 	if (res.success) {
		// 		this.customerServiceData = res.data
		// 	}
		// },
		// 获取交易群聊
		async getTradeGroupId() {
			let data = {
				orderNo: this.$route.query.orderNo
			}
			const res = await this.$api.getGroupIdByOrderNo(data)
			if (res.success) {
				this.customerServiceData = res.data
			}
		},
		// 查看聊天客服
		async getClickCustomerService(retryCount = 1) {
			// const isTradeGroup = this.$route.query.status == '3'
            await this.getTradeGroupId()
            if (this.customerServiceData) {
                this.$store.dispatch('ry/join', {
                    targetId: this.customerServiceData,
                    conversationType: 3
                })
            } else {
                if (retryCount < 3) { // 假设最大重试次数为3
                    setTimeout(() => {
                        getClickCustomerService(retryCount + 1)
                    }, 5000)
                }
                else {
                    this.$message({
                        message: '请您前往消息列表进入群聊进行交易流程！',
                        duration: 5000
                    })
                }
            }
			// if (isTradeGroup) {
			// } else {
			// 	await this.getOrderCustomerService()
			// 	if (this.customerServiceData?.groupId) {
			// 		this.$store.dispatch('ry/join', {
			// 			targetId: this.customerServiceData?.groupId || this.customerServiceData?.id,
			// 			conversationType: this.customerServiceData?.groupId ? 3 : 1
			// 		})
			// 	} else {
			// 		if (retryCount < 3) { // 假设最大重试次数为3
            //             setTimeout(() => {
            //                 getClickCustomerService(retryCount + 1)
            //             }, 5000)
            //         }
            //         else {
            //             this.$message({
            //                 message: '请您前往消息列表进入群聊进行交易流程！',
            //                 duration: 5000
            //             })
            //         }
			// 	}
			// }
		},
        // 回首页
        gotoHomePage() {
            this.$router.push('/')
        },
        // 进入订单详情
        gotoOrderDtl() {
            this.$router.push({
                path: '/account/buyerDetails',
                query: { orderNo: this.$route.query.orderNo, parPage: 'true' }
            })
        }
    },
    mounted() {
        this.getTradeGroupId()
    }
}
